import { ClassicCard } from '@braze/web-sdk';
import { createAction, props } from '@ngrx/store';

export interface NotificationStateInterface {
  newCards: number,
  notificationsList: ClassicCard[];
}

export const reset = createAction('[Address Modal] Reset All');
export const allViewed = createAction('[Notifications] mark cards as vieweds');
export const updateCards = createAction('[Notifications] Update cards list', props<{notifications: ClassicCard[]}>());